import { useState, useEffect } from 'react';
import { DEFAULT_PAGE_SIZE } from '@constants/pagination';
import { useQuery } from '@apollo/client';
import { AUDIT_OATT, AUDIT_OATT_COUNT, AUDIT_BY_OATT_CUSTOMER } from 'graphql/audit.gql';
import { message } from 'antd';

export const useOattAuditData = (
  startDate?: string,
  endDate?: string,
  customerId?: number | null,
  suppressQuery?: boolean,
) => {
  const [pageVars, setPageVars] = useState({ limit: DEFAULT_PAGE_SIZE, offset: 0 });

  const isByCustomer = !!customerId;

  const { data: customerData, loading: customerLoading, error: customerError } = useQuery(
    AUDIT_BY_OATT_CUSTOMER,
    {
      variables: { customerId: customerId!, startDate, endDate, ...pageVars },
      fetchPolicy: 'cache-and-network',
      skip: !isByCustomer || !!suppressQuery,
    }
  );

  const { data: allData, loading: allLoading, error: allError } = useQuery(AUDIT_OATT, {
    variables: { startDate, endDate, ...pageVars },
    fetchPolicy: 'cache-and-network',
    skip: isByCustomer || !!suppressQuery,
  });

  const { data: countData } = useQuery(AUDIT_OATT_COUNT, {
    variables: { startDate, endDate },
    fetchPolicy: 'cache-and-network',
    skip: isByCustomer || !!suppressQuery,
  });

  const error = customerError ?? allError;
  useEffect(() => {
    if (error) message.error(error.message || 'Failed to fetch OATT audit events');
  }, [error]);

  const events = suppressQuery
    ? []
    : isByCustomer
      ? (customerData?.auditByOattCustomer ?? [])
      : (allData?.auditOatt ?? []);

  const totalCount = suppressQuery
    ? 0
    : isByCustomer
      ? (events.length === pageVars.limit ? pageVars.offset + events.length + 1 : pageVars.offset + events.length)
      : (countData?.auditOattCount ?? 0);

  return {
    data: events,
    totalCount,
    loading: isByCustomer ? customerLoading : allLoading,
    error,
    currentPage: Math.floor(pageVars.offset / pageVars.limit) + 1,
    pageSize: pageVars.limit,
    onChangePage: (page: number, size: number) => {
      setPageVars({ limit: size, offset: (page - 1) * size });
    },
    refetch: () => {},
  };
};
